import {Injectable} from "@angular/core";
import {BaseService} from "./base-service";
import {Http} from "@angular/http";
import {Settings} from "../settings/base";
/**
 * Created by kennethmwangi on 22/04/2017.
 */

@Injectable()
export class HospitalService extends BaseService {


  constructor(private http: Http, private _settings: Settings) {

    super();
  }

  getHospitals() {

    return this.http.get(this._settings.base_url+ "hospitals/", this.createHeaders("Authorization"))
      .map(res => res.json());
  }

  getHospital(id) {
    return this.http.get(this.getHospitalUrl(id), this.createHeaders("Authorization"))
      .map(res => res.json());
  }

  getHospitalBranches(id){
    return this.http.get(this._settings.base_url+ "hospitals/"+id+"/branches/", this.createHeaders("Authorization"))
      .map(res => res.json());
  }

  private getHospitalUrl(id) {
    return this._settings.base_url+ "hospitals/" + id;

  }

}



// WEBPACK FOOTER //
// ./src/providers/hospital-service.ts